var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivityResumed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 38 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ActivityResumed_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 18,
  r: 15.273,
  fill: "#40B481",
  stroke: "#fff",
  strokeWidth: 1.455
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m9.05 15.407 1.84 1.839c4.57-4.57 11.981-4.57 16.551 0l1.84-1.84c-5.582-5.58-14.64-5.58-20.23 0m7.357 7.356 2.759 2.759 2.758-2.759a3.896 3.896 0 0 0-5.517 0m-3.678-3.678 1.839 1.839a6.505 6.505 0 0 1 9.195 0l1.84-1.84c-3.55-3.548-9.316-3.548-12.874 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ActivityResumed_svg__a",
  width: 38,
  height: 38,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_712_2242"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_712_2242",
  result: "effect2_dropShadow_712_2242"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "effect3_dropShadow_712_2242"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_712_2242",
  result: "effect3_dropShadow_712_2242"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_712_2242",
  result: "shape"
})))));
export { SvgActivityResumed as ReactComponent };
export default __webpack_public_path__ + "static/media/ActivityResumed.8bbae3a6.svg";